import React, { Fragment } from 'react';
import {
    setAppCustomTitle
} from "../../reducers/ThemeOptions";
import { connect } from "react-redux";
import Common from '../Common';
import Pricing from './Pricing';
import { getOrganizationInfo, isMobile } from '../../Common/Appcommon';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { Button } from 'reactstrap';

class PricingList extends React.Component {
    constructor(props) {
        super(props);
        this.callChildMethod = null;
        this.state={
            showloader:true,
        }
    }

    componentDidMount = async () => {
    };

    buttonHandle = () => {
        this.createButton.current.handleModalState();
    };

    showloader = (status) => {
        this.setState({ isLoading: status });
    };

    getTitleBody = () => {
        return (
            <div className={'pricing-header-right'}>
                <Button className='add-plan-btn theme-bg-g' onClick={e => {this.buttonHandle()}}>
                    <FontAwesomeIcon icon={faPlus} className='me-2'/>
                    Create Subscription Tier
                </Button>
            </div>
        )
    }

    setChildMethod = (methodRef) => {
        this.callChildMethod = methodRef;
    };
    
    buttonHandle = () => {
        if (this.callChildMethod) {
            this.callChildMethod();
        }
    };

    render() {
        let accountinfo = {
            account_id : getOrganizationInfo("Account_ID"),
            data_row: {
                appid : getOrganizationInfo("appid"),
            }
        };
        return (
            <Fragment>
                <Common
                    title={
                        "Subscription Tiers"
                    }
                    titleContent={
                        <span>Subscription Tiers</span>
                    }
                    titleBody={!isMobile() && this.getTitleBody()}
                    mainContent={
                        <Pricing
                            onReady={this.setChildMethod}
                            accountinfo={accountinfo} 
                            isSubAccountView={false} 
                            showloader={this.showloader}
                            currency={this.props.currency}
                        />
                    }
                    mainLoader={this.state.isLoading}  
                />
            </Fragment>
        )
    }
}

const mapStateToProps = state => ({
    appCustomTitle: state.ThemeOptions.appCustomTitle
});

const mapDispatchToProps = dispatch => ({
    setAppCustomTitle: title => dispatch(setAppCustomTitle(title)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PricingList);